var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.133,
    height: 28.92,
    viewBox: "0 0 32.133 28.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_002-graph",
    "data-name": "002-graph",
    transform: "translate(0 -25.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_87",
    "data-name": "Grupo 87",
    transform: "translate(0 25.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_385",
    "data-name": "Caminho 385",
    d: "M28.92,25.6a3.207,3.207,0,0,0-2.309,5.438L20.74,42.777a3.107,3.107,0,0,0-.389-.04,3.2,3.2,0,0,0-1.209.24l-4.558-5.125A3.175,3.175,0,0,0,15,36.311,3.213,3.213,0,1,0,9.357,38.4l-5.57,9.756a3.223,3.223,0,0,0-.574-.058,3.252,3.252,0,1,0,2.425,1.129l5.57-9.756a3.055,3.055,0,0,0,1.779-.182l4.558,5.125a3.174,3.174,0,0,0-.407,1.541,3.213,3.213,0,1,0,5.523-2.225l5.871-11.739a3.107,3.107,0,0,0,.389.04,3.213,3.213,0,1,0,0-6.427ZM3.213,52.378a1.071,1.071,0,1,1,1.071-1.071A1.071,1.071,0,0,1,3.213,52.378Zm8.569-15a1.071,1.071,0,1,1,1.071-1.071A1.071,1.071,0,0,1,11.782,37.382Zm8.569,9.64a1.071,1.071,0,1,1,1.071-1.071A1.071,1.071,0,0,1,20.351,47.022ZM28.92,29.884a1.071,1.071,0,1,1,1.071-1.071A1.071,1.071,0,0,1,28.92,29.884Z",
    transform: "translate(0 -25.6)",
    fill: "#19a4bb"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopular);
export default __webpack_public_path__ + "static/media/popular.8e9f31036f824ff5b271aea950783c46.svg";
export { ForwardRef as ReactComponent };